import React from 'react';
import { Info } from 'lucide-react';

interface ReceiptExtraInfoProps {
  /** Allerede resolvede verdier (kun de med innhold). Tom liste => rendrer ingenting. */
  values: string[];
  /** Kompakt variant for listevisning (mindre tekst, mindre luft). */
  compact?: boolean;
  className?: string;
}

/**
 * ReceiptExtraInfo - viser profil-konfigurert tilleggsinfo fra innkjøpsordrelinjen
 * i varemottak. Kun verdiene vises (ingen label), hver på egen rad slik at det
 * fungerer på små flater (nettbrett). Vises kun når det finnes verdier.
 */
export const ReceiptExtraInfo: React.FC<ReceiptExtraInfoProps> = ({
  values,
  compact = false,
  className = '',
}) => {
  if (!values || values.length === 0) return null;

  return (
    <div className={`flex flex-col gap-0.5 ${className}`}>
      {values.map((value, idx) => (
        <div
          key={idx}
          className={`flex items-start gap-1.5 text-gray-700 ${compact ? 'text-xs' : 'text-sm'}`}
        >
          <Info className={`flex-shrink-0 mt-0.5 text-gray-400 ${compact ? 'h-3 w-3' : 'h-3.5 w-3.5'}`} />
          <span className="break-words">{value}</span>
        </div>
      ))}
    </div>
  );
};
